import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { Role } from '../../models/roles/role';

@Injectable()
export class RoleService {

    public roles: Role[];
    public rolesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.roles = [];
        this.rolesObject = {};
    }

    public getAll(): Observable<Role[]> {
        if (!!this.roles && this.roles.length > 0) {
            return Observable.create((observer: Subscriber<Role[]>) => {
                observer.next(this.roles);
                observer.complete();
            });
        }
        const url = 'application-roles/all';
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.roles = r.Result;
                this.rolesObject = this.roles.reduce((result, ar) => {
                    result[String(ar.Id)] = result[String(ar.Id)] || {};
                    result[String(ar.Id)] = ar;
                    return result;
                }, {});
            } else {
                console.error('UserService > getAll > response', r);
            }
            return this.roles;
        }).catch(this.handleError);
    }

    public add(name: string, description: string, permissionIds: number[]) {
        const url = 'application-roles/add';
        return this.http.post(url, {
            Name: name,
            Description: description,
            PermissionIds: permissionIds
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(id: string, name: string, description: string, permissionIds: number[]) {
        const url = 'application-roles/edit';
        return this.http.put(url, {
            Id: id,
            Name: name,
            Description: description,
            PermissionIds: permissionIds
        }).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: string) {
        const url: string = 'application-roles/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/roles/role.service.ts